import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { KeyRound, Send } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import BienvenidaMiJPM from './BienvenidaMiJPM';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const correoValido = (c) => /[^@\s]+@[^@\s]+\.[^@\s]+/.test(c || '');

// Botones de Gerencia en la lista de clientes: crear el acceso a Mi JPM y enviarlo
export default function AccesoMiJPMBotones({ cliente, onCreado }) {
  const [creando, setCreando] = useState(false);
  const [abierto, setAbierto] = useState(false);
  const habilitado = !!cliente.mi_jpm?.habilitado;

  const crear = async () => {
    if (!correoValido(cliente.correo)) { toast.error('Agrega un correo válido al cliente: será su usuario de Mi JPM'); return; }
    if (!window.confirm(`¿Crear el acceso a Mi JPM para ${cliente.nombre}?\nUsuario y contraseña inicial: ${cliente.correo}`)) return;
    setCreando(true);
    try {
      await axios.post(`${API_URL}/api/mi-jpm/cliente/${cliente.id}/habilitar`, {}, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      toast.success(`Acceso a Mi JPM creado para ${cliente.nombre}. Ya puedes enviarlo.`);
      onCreado(cliente.id);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudo crear el acceso');
    } finally {
      setCreando(false);
    }
  };

  if (!habilitado) {
    return (
      <button onClick={crear} disabled={creando} title="Crear acceso a Mi JPM" data-testid={`crear-acceso-${cliente.id}`}
        className="flex items-center gap-1.5 px-3 py-2 border border-[#D4AF37]/60 text-[#D4AF37] hover:bg-[#D4AF37]/10 rounded-lg text-sm font-medium transition-colors disabled:opacity-50">
        <KeyRound className="w-4 h-4" />
        <span className="hidden sm:inline">{creando ? 'Creando…' : 'Crear acceso'}</span>
      </button>
    );
  }

  return (
    <>
      <button onClick={() => setAbierto(true)} title="Enviar acceso a Mi JPM" data-testid={`enviar-acceso-${cliente.id}`}
        className="flex items-center gap-1.5 px-3 py-2 bg-[#D4AF37] hover:bg-[#C4A030] text-black rounded-lg text-sm font-medium transition-colors">
        <Send className="w-4 h-4" />
        <span className="hidden sm:inline">Enviar acceso</span>
      </button>
      <Dialog open={abierto} onOpenChange={setAbierto}>
        <DialogContent className="max-h-[90vh] overflow-y-auto border-zinc-800 bg-zinc-900 text-white sm:max-w-lg" data-testid={`dialogo-enviar-acceso-${cliente.id}`}>
          <DialogHeader>
            <DialogTitle>Enviar acceso a Mi JPM</DialogTitle>
            <DialogDescription className="text-zinc-400">{cliente.nombre} · {cliente.correo}</DialogDescription>
          </DialogHeader>
          {abierto && <BienvenidaMiJPM clienteId={cliente.id} />}
        </DialogContent>
      </Dialog>
    </>
  );
}
